

import Controller from "./core/Controller";
import { EventBus } from "./shared/eventBus";
import { UiManager } from "./ui";

const eventBus = new EventBus<any>();

const uiManager = new UiManager(eventBus);

const controller = new Controller(eventBus);
controller.boot();



